import SectionList from "../components/category/SectionList";

const CategoryPage = () => {
  return (
    <SectionList/>
  );
};
export default CategoryPage;
